import { setChatListSyncFailed, setChatListSyncPending, setChatListSyncSucceed } from './actions';
import { getChatsV2 } from './getChatsV2';
import { DEFAULT_SYNC_PAGE_SIZE } from '../../constants/syncPageSize';
import { currentOpenChatIDSelector, isShowSubAgentChatListSelector } from '../../selectors';
import { syncChatsV2 } from '../../services/chatsList/syncChatsV2';
import { EHostType } from '../../types/hostType';
import { TThunkAction } from '../../types/redux/thunk';
import { getQueryParamsFetchChatsList } from '../../utils/getQueryParamsFetchChatsList';
import { getSyncPagesByChats } from '../../utils/getSyncPagesByChats';
import { closeChat } from '../chatWindow';

/**
 * Синхронизировать чаты чанками
 */
export const synchronizeChatsV2 = (): TThunkAction<Promise<void>> => async (dispatch, getState, context) => {
  const state = getState();

  const {
    hostType,
    chatList,
    masterFilters: { selectedSubAgentId },
  } = state;

  // TODO убрать после фикса на беке
  if (hostType === EHostType.Frame) {
    return;
  }

  const { currentRoute, chats } = chatList;

  const { status, filterBy } = getQueryParamsFetchChatsList(currentRoute);

  const subAgentRealtyUserId = isShowSubAgentChatListSelector(state) ? selectedSubAgentId : undefined;

  dispatch(setChatListSyncPending());

  const commonProps = {
    subAgentRealtyUserId,
    status,
    filterBy,
  };

  const syncPageSize = context.config.get<number>('frontend-chats.syncPageSize') || DEFAULT_SYNC_PAGE_SIZE;
  const syncPages = getSyncPagesByChats({ chatsCount: chats.length, syncPageSize });

  const pagesForSyncParameters = Array.from({ length: syncPages }).map((_, index) => {
    const startIndex = index * syncPageSize;
    const chatListChunk = chats.slice(startIndex, startIndex + syncPageSize);

    const lastChatAtChunk = chatListChunk[chatListChunk.length - 1];
    const lastChatAtPreviousChunk = index ? chats[startIndex - 1] : undefined;

    return {
      ...commonProps,
      chatIds: chatListChunk.map(chat => chat.chatId),
      minDatetimeForSorting: new Date(lastChatAtChunk.updated).toISOString(),
      maxDatetimeForSorting: lastChatAtPreviousChunk
        ? new Date(lastChatAtPreviousChunk.updated).toISOString()
        : undefined,
    };
  });

  const chunksSyncResponses = await Promise.all(
    pagesForSyncParameters.map(parameters =>
      syncChatsV2(context, {
        parameters,
      }),
    ),
  );

  const syncErrors = chunksSyncResponses.map(response => response.error).filter(Boolean) as string[];

  if (!syncErrors.length) {
    dispatch(setChatListSyncSucceed(chunksSyncResponses.flatMap(response => response.chats || [])));

    const movedChatIds = chunksSyncResponses.flatMap(response => response.movedChatIds || []);

    if (movedChatIds.length > 0) {
      const updatedState = getState();

      const chatId = currentOpenChatIDSelector(updatedState);

      // Если открыт чат, который был перемещен, сбрасываем открытый чат
      if (chatId && movedChatIds.includes(chatId)) {
        dispatch(closeChat());
      }
    }

    return;
  }

  if (syncErrors.includes('tooManyRecords')) {
    dispatch(getChatsV2({ mergeResult: false }));

    return;
  }

  dispatch(setChatListSyncFailed());
};
